import { PASSWORD_RULE_HINT } from '@gestao/shared'

export const auth = {
  tagline: 'Cobrança com método. Cada contato registrado, cada acordo acompanhado.',
  internalUse: (client: string) => `Uso interno • ${client}`,
  email: 'E-mail',
  password: 'Senha',
  showPassword: 'Mostrar senha',
  login: {
    title: 'Entrar',
    remember: 'Lembrar este dispositivo',
    submit: 'Entrar',
    forgot: 'Esqueci minha senha',
  },
  forgot: {
    title: 'Esqueci minha senha',
    description: 'Informe o e-mail da sua conta. Enviamos um link para você criar uma senha nova.',
    submit: 'Enviar link',
    back: 'Voltar para o login',
    sentTitle: 'Confira seu e-mail',
    sentDescription: (email: string) =>
      `Se ${email} tiver acesso ao sistema, o link chega em alguns minutos. Ele vale por 30 minutos e funciona uma vez.`,
    sentHint: 'Não chegou? Confira a caixa de spam ou peça outro link.',
    sendAgain: 'Pedir outro link',
  },
  reset: {
    title: 'Criar senha nova',
    description: 'Escolha a senha que você vai usar daqui em diante.',
    password: 'Senha nova',
    confirm: 'Confirme a senha nova',
    submit: 'Redefinir senha',
    success: 'Senha redefinida. Entre com a senha nova.',
    invalidTitle: 'Este link não vale mais',
    invalidDescription:
      'Links de redefinição valem por 30 minutos e funcionam uma vez. Peça um novo para continuar.',
    requestNew: 'Pedir link novo',
    checking: 'Conferindo o link…',
  },
  change: {
    title: 'Crie sua senha',
    description:
      'Você entrou com uma senha temporária. Troque por uma senha só sua para continuar.',
    current: 'Senha temporária',
    password: 'Senha nova',
    confirm: 'Confirme a senha nova',
    submit: 'Salvar senha nova',
    success: 'Senha nova salva.',
    signOut: 'Sair',
  },
  passwordRules: {
    label: 'Requisitos da senha',
    hint: PASSWORD_RULE_HINT,
    minLength: 'Pelo menos 10 caracteres',
    hasLetter: 'Pelo menos uma letra',
    hasNumber: 'Pelo menos um número',
    met: '(atendido)',
    pending: '(pendente)',
  },
  confirmMismatch: 'As duas senhas precisam ser iguais.',
  sameAsCurrent: 'A nova senha precisa ser diferente da atual.',
} as const
